export default "__VITE_ASSET__DxGNP1EK__"